module.exports = __webpack_public_path__ + "static/media/three-bg.3a64a284.png";